import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
    const { currentUser, token } = useSelector((state) => state.user);
    const isAuthenticated = !!token && !!currentUser;
    const isAdmin = currentUser?.roles?.includes('admin');

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Temp bulk-uploaded users must change password before using the app
    if (currentUser.must_change_password) {
        return <Navigate to="/change-password-required" replace />;
    }

    // Check approval status for non-admin users
    if (!isAdmin && currentUser.approval_status !== 'approved') {
        return <Navigate to="/pending-approval" replace />;
    }

    return children;
};

export default PrivateRoute; 